'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import CartTotal from './components/CartTotal.vue';

var _class = function _class() {
    _classCallCheck(this, _class);

    // Register component globaly
    Vue.component('cart-total', CartTotal);
};

export default _class;


//////////////////
// WEBPACK FOOTER
// ./resources/templates/semperit/assets/js/modules/cart-total/index.js
// module id = null
// module chunks = 